import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "listingSettings" }

import { ref, computed, watch, inject, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import ListingSettingsColumn from 'vcomponents/common/listing/settings/ListingSettingsColumn.vue';
import { Translator } from 'types/injects/translator.type';
import { PushToast } from 'types/injects/pushToast.type';
import { cloneDeep } from 'lodash';
import type { ListingSettingsColumnData } from 'js/types/components/listing/listing.type';
import { CompassEvent } from 'js/types/events';

interface Props {
    searchableColumns?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ListingSettings',
  props: {
    searchableColumns: { type: Boolean, default: true }
  },
  emits: ["updateColumns", "resetColumns"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const $t = inject('$t') as Translator;
const $pushToast = inject('$pushToast') as PushToast;

const store = useStore();

const isOpen = ref(false);
const columns = ref<ListingSettingsColumnData[]>([]);
const snapshot = ref<ListingSettingsColumnData[]>([]);

const title = $t.__('listing.settings.ListingSettings.title');

const storeColumns = computed(() => store.state.listingSettingsStores?.columns ?? []);

const notifySuccess = (): void => {
    $pushToast({
        type: CompassEnums.ToastType.SUCCESS,
        icon: true,
        text: $t.__('listing.settings.ListingSettings.push_message.success'),
    });
};

const primaryAction = {
    label: $t.__('common.actions.apply'),
    action: () => {
        emit('updateColumns', cloneDeep(columns.value));
        notifySuccess();
        isOpen.value = false;
    },
};

const secondaryActions = [
    {
        label: $t.__('common.actions.reset'),
        action: () => {
            emit('resetColumns');
            notifySuccess();
            isOpen.value = false;
        },
    },
];

const openDialog = (): void => {
    snapshot.value = cloneDeep(columns.value);
    isOpen.value = true;
};

const cancelDialog = (): void => {
    columns.value = snapshot.value;
    isOpen.value = false;
};

const syncFromStore = (): void => {
    columns.value = cloneDeep(storeColumns.value);
};

watch(storeColumns, syncFromStore, { immediate: true });

EventBus.on(CompassEvent.TABLE_COLUMNS_RESIZED, syncFromStore);

onBeforeUnmount(() => {
    EventBus.off(CompassEvent.TABLE_COLUMNS_RESIZED, syncFromStore);
});

return (_ctx: any,_cache: any) => {
  const _component_CompassIconButton = _resolveComponent("CompassIconButton")!
  const _component_CompassTooltip = _resolveComponent("CompassTooltip")!
  const _component_CompassModal = _resolveComponent("CompassModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CompassTooltip, {
      content: _unref(title),
      arrow: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassIconButton, {
          icon: "settings",
          class: "listingSettings__button",
          onClick: openDialog
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["content"]),
    _createVNode(_component_CompassModal, {
      title: _unref(title),
      primaryAction: primaryAction,
      secondaryActions: secondaryActions,
      visible: isOpen.value,
      size: _ctx.CompassEnums.ModalSize.SMALL,
      "onUpdate:visible": cancelDialog
    }, {
      default: _withCtx(() => [
        _createVNode(ListingSettingsColumn, {
          columns: columns.value,
          searchable: __props.searchableColumns,
          onUpdateColumns: _cache[0] || (_cache[0] = 
                    (cols) => {
                        columns.value = cols;
                    }
                )
        }, null, 8 /* PROPS */, ["columns", "searchable"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title", "visible", "size"])
  ]))
}
}

})